var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("el-form", {
    attrs: {
      inline: true
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "日期"
    }
  }, [[_c("data-options", {
    attrs: {
      clearable: false
    },
    model: {
      value: _vm.dateInfo,
      callback: function callback($$v) {
        _vm.dateInfo = $$v;
      },
      expression: "dateInfo"
    }
  })]], 2), _c("el-form-item", {
    attrs: {
      label: "服务器列表"
    }
  }, [_c("server-list", {
    attrs: {
      isCache: "",
      multiple: true,
      all: ""
    },
    model: {
      value: _vm.serverInfo,
      callback: function callback($$v) {
        _vm.serverInfo = $$v;
      },
      expression: "serverInfo"
    }
  })], 1), _c("el-form-item", {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn() {
        return [_c("el-button", {
          attrs: {
            type: "primary"
          },
          on: {
            click: function click($event) {
              return _vm.onSearchBtn();
            }
          }
        }, [_vm._v(" 查询 ")])];
      },
      proxy: true
    }])
  })], 1), _c("el-card", {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      header: "通关比例对比"
    }
  }, [_c("div", {
    ref: "winRatioChart",
    staticStyle: {
      height: "300px"
    }
  })]), _vm._l(_vm.dataList, function (item) {
    return _c("div", {
      key: item.date_str
    }, [_c("el-card", {
      staticStyle: {
        "margin-bottom": "20px"
      }
    }, [_c("div", {
      staticStyle: {
        "margin-bottom": "20px",
        display: "flex",
        "justify-content": "center"
      }
    }, [_c("h3", [_vm._v(_vm._s(item.date_str) + " ")]), _c("h3", [_vm._v("（新增角色：" + _vm._s(item.new_role) + "）")])]), _c("el-table", {
      attrs: {
        data: item.list,
        border: "",
        "header-cell-style": {
          "background-color": "#effeff"
        }
      }
    }, [_c("el-table-column", {
      attrs: {
        label: "关卡",
        prop: "guanqia_no"
      }
    }), _c("el-table-column", {
      attrs: {
        label: "开始角色数",
        prop: "start_role"
      }
    }), _c("el-table-column", {
      attrs: {
        label: "通关角色数",
        prop: "win_role"
      }
    }), _c("el-table-column", {
      scopedSlots: _vm._u([{
        key: "header",
        fn: function fn() {
          return [_vm._v(" 通关率 "), _c("el-tooltip", {
            attrs: {
              effect: "dark",
              content: "通关角色数 / 开始角色数",
              placement: "top-start"
            }
          }, [_c("i", {
            staticClass: "el-icon-warning-outline"
          })])];
        },
        proxy: true
      }, {
        key: "default",
        fn: function fn(_ref) {
          var row = _ref.row;
          return [_vm._v(" " + _vm._s(row["win_rate"]) + "% ")];
        }
      }], null, true)
    }), _c("el-table-column", {
      scopedSlots: _vm._u([{
        key: "header",
        fn: function fn() {
          return [_vm._v(" 开始比例 "), _c("el-tooltip", {
            attrs: {
              effect: "dark",
              content: "开始关卡数 / (新增角色数 或 上一关通关角色数)",
              placement: "top-start"
            }
          }, [_c("i", {
            staticClass: "el-icon-warning-outline"
          })])];
        },
        proxy: true
      }, {
        key: "default",
        fn: function fn(_ref2) {
          var row = _ref2.row;
          return [_vm._v(" " + _vm._s(row["start_ratio"]) + "% ")];
        }
      }], null, true)
    }), _c("el-table-column", {
      scopedSlots: _vm._u([{
        key: "header",
        fn: function fn() {
          return [_vm._v(" 通关比例 "), _c("el-tooltip", {
            attrs: {
              effect: "dark",
              content: "通关角色数 / 新增角色数",
              placement: "top-start"
            }
          }, [_c("i", {
            staticClass: "el-icon-warning-outline"
          })])];
        },
        proxy: true
      }, {
        key: "default",
        fn: function fn(_ref3) {
          var row = _ref3.row;
          return [_vm._v(" " + _vm._s(row["win_ratio"]) + "% ")];
        }
      }], null, true)
    }), _c("el-table-column", {
      scopedSlots: _vm._u([{
        key: "header",
        fn: function fn() {
          return [_vm._v(" 流失比例 "), _c("el-tooltip", {
            attrs: {
              effect: "dark",
              content: "（上一关通关角色数 - 本关通关角色数）/ 上一关通关角色数",
              placement: "top-start"
            }
          }, [_c("i", {
            staticClass: "el-icon-warning-outline"
          })])];
        },
        proxy: true
      }, {
        key: "default",
        fn: function fn(_ref4) {
          var row = _ref4.row;
          return [_vm._v(" " + _vm._s(row["lost_ratio"]) + "% ")];
        }
      }], null, true)
    })], 1)], 1)], 1);
  })], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };